/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.13 CAPRIATA.glb 
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function CAPRIATA(props) {
  const { nodes, materials } = useGLTF("/3d/CAPRIATA.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.IfcBeamCAPRIATA.geometry}
        material={materials["ACCIAIO-S275JR"]}
        position={[-0.075, 5.974, -18.153]}
      />
    </group>
  );
}

useGLTF.preload("/CAPRIATA.glb");
